/**
 * When the app is served on the public landing host (e.g. `noizbloc.com`),
 * auth flows redirect to the client app on `central.noizbloc.com`.
 * On the client host itself, in-app navigate() calls are used.
 *
 * Configure via frontend/.env:
 *   REACT_APP_APP_URL=https://central.noizbloc.com
 *   REACT_APP_LANDING_HOST=noizbloc.com
 */
const APP_URL = process.env.REACT_APP_APP_URL || "";
const LANDING_HOST = (process.env.REACT_APP_LANDING_HOST || "").toLowerCase();

export function isLandingHost() {
  if (typeof window === "undefined") return false;
  const host = (window.location.hostname || "").toLowerCase();
  // Match the exact landing host and any www prefix.
  return !!LANDING_HOST && (host === LANDING_HOST || host === `www.${LANDING_HOST}`);
}

/**
 * Send the user to a path on the client app. On the landing host this hard-redirects
 * to `${APP_URL}${path}`; otherwise the caller should use react-router's navigate().
 * Returns true when it triggered an external redirect (so callers can skip navigate()).
 */
export function goToApp(path = "/") {
  if (typeof window === "undefined") return false;
  const target = path.startsWith("/") ? path : `/${path}`;
  if (isLandingHost() && APP_URL) {
    window.location.href = `${APP_URL.replace(/\/$/, "")}${target}`;
    return true;
  }
  return false;
}
